// @flow
import React from 'react';
import SVGInline from 'react-svg-inline';

import type { CoverBackgroundProps } from './types';

const CoverBackground = ({ template }: CoverBackgroundProps) => <SVGInline svg={template} />;

export default React.memo<CoverBackgroundProps>(CoverBackground);
